'use client';

import dynamic from 'next/dynamic';

const FlexboxDemo = dynamic(() => import('./index'));

export default FlexboxDemo;
